import { Playback } from './playback';
import { SoundPlayerState } from './sound-types';
import { get } from 'svelte/store';
import { tick } from 'svelte';
export class PredefinedSoundPlayer {
    constructor(soundPlayerState) {
        this.soundPlayerState = soundPlayerState;
        this.sounds = {
            shortNotification: 'sound/all-eyes-on-me-465-delayed.wav',
            mediumNotification: 'sound/you-know-its-morning-again-211.mp3', // https://notificationsounds.com/wake-up-tones/you-know-its-morning-again-211
            longNotification: 'sound/lovingly-618.mp3', // https://notificationsounds.com/wake-up-tones/lovingly-618
        };
        this.newConversationNotificationLoop = new Playback(this.sounds.mediumNotification, true);
        this.newMessageNotification = new Playback(this.sounds.shortNotification, false);
    }
    async preload() {
        if (get(this.soundPlayerState) === SoundPlayerState.INITIAL) {
            this.soundPlayerState.set(SoundPlayerState.PRELOADING);
            await Promise.all([
                this.newMessageNotification.preload(),
                this.newConversationNotificationLoop.preload()
            ]);
            this.soundPlayerState.set(SoundPlayerState.PRELOADED);
        }
    }
    async playNewMessageNotification() {
        await tick();
        await this.newMessageNotification.startFromBeginning();
    }
    muteNewMessageNotification() {
        this.newMessageNotification.mute();
    }
    unmuteNewMessageNotification() {
        this.newMessageNotification.unmute();
    }
    async playNewConversationNotificationLoop() {
        await tick();
        await this.newConversationNotificationLoop.startFromBeginning();
    }
    muteNewConversationNotificationLoop() {
        this.newConversationNotificationLoop.mute();
    }
    unmuteNewConversationNotificationLoop() {
        this.newConversationNotificationLoop.unmute();
    }
    async stopNewConversationNotificationLoop() {
        await tick();
        await this.newConversationNotificationLoop.stop();
    }
}
